import React from 'react';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import { getCsrfToken } from './authenticityToken';

describe('Meta True', () => {

  beforeEach(() => {
    let meta = document.createElement('meta');
    meta.name = "csrf-token";
    meta.content = "MetaContent";
    document.body.appendChild(meta);
  });
  
  test('getCsrfToken Retrun Content', () => {
    expect(getCsrfToken()).toBe('MetaContent');
    //screen.debug();
  });
});

describe('Meta False', () => {
  beforeEach(() => {
    let meta = document.querySelector('meta[name=csrf-token');
    meta.remove();
  });

  test('getCsrfToken Retrun Whitespace', () => {

    expect(getCsrfToken()).toBe('');
    //screen.debug();
  });
});
